export default "__VITE_ASSET__3874c6f0__"